export default __webpack_public_path__ + "3e9d462e83d845a9f5b002483fa30cc6.png";